import { getCookie, setCookie, locationParam } from './forms/helpers';

const FIRST_TOUCH_COOKIE_NAME = 'dr_first_touch';
const AD_CLICK_IDS_COOKIE_NAME = 'dr_ad_click_ids';

const UTM_PARAM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term'
]

const AD_CLICK_IDS_KEYS = {
  gclid: 'gclid',     // GOOGLE CLICK ID
  fbclid: 'fbclid',    // META CLICK ID
  li_fat_id: 'li_fat_id', // LINKEDIN CLICK ID
  sc_cid: 'ScCid'      // SNAPCHAT CLICK ID
}

function get_parsed_cookie(cookie_name) {
  var cookie_content = getCookie(cookie_name);

  if (cookie_content) {
    return JSON.parse(cookie_content);
  }
}

export function get_first_touch() {
  return get_parsed_cookie(FIRST_TOUCH_COOKIE_NAME);
}

export function get_ad_click_ids() {
  return get_parsed_cookie(AD_CLICK_IDS_COOKIE_NAME);
}

export function get_ad_click_ids_from_touch(touch) {
  var values = {};

  Object.entries(AD_CLICK_IDS_KEYS).forEach(function ([click_id_key, param]) {
    values[click_id_key] = touch[param];
  });

  return values;
}

export function calculate_first_touch() {
  var values = {}

  UTM_PARAM_KEYS.forEach(function(utm_param_key) {
    values[utm_param_key] = locationParam(location.search, utm_param_key);
  });

  Object.entries(AD_CLICK_IDS_KEYS).forEach(function ([click_id_key, param]) {
    values[click_id_key] = locationParam(location.search, param);
  });

  return values;
}

export function calculate_ad_click_ids() {
  var values = {}

  Object.entries(AD_CLICK_IDS_KEYS).forEach(function ([click_id_key, param]) {
    var click_id = locationParam(location.search, param);

    if (click_id != null && values[click_id_key] == null) {
      values[click_id_key] = click_id;
    }
  });

  return values;
}

export function calculate_ga_client_id(config) {
  var ga_client_id = null;

  if (typeof (gtag) === 'function' && config.form.tracking.google_analytics_measurement_id) {
    gtag('get', config.form.tracking.google_analytics_measurement_id, 'client_id', (client_id) => {
      ga_client_id = client_id;
    })
  } else {
    if (typeof (ga) === 'function') {
      ga(function () {
        var trackers = ga.getAll();

        if (trackers.length == 0) {
          console.warn('[Driftrock] No Google Analytics Trackers available');
          return;
        }

        if (trackers.length > 1 && !config.form.tracking.google_analytics_id) {
          console.warn('[Driftrock] Multiple Google Analytics Trackers but Tracker ID not specified');
          return;
        }

        if (trackers.length == 1 && !config.form.tracking.google_analytics_id) {
          ga_client_id = trackers[0].get('clientId');
          return;
        }

        for (var i = 0; i < trackers.length; i += 1) {
          if (trackers[i].get('trackingId') === config.form.tracking.google_analytics_id) {
            ga_client_id = trackers[i].get('clientId');
            return;
          }
        }
      });
    } else {
      console.warn('[Driftrock] Google Analytics not setup');
    }
  }

  return ga_client_id;
}

export function set_first_touch() {
  const cookie_content = getCookie(FIRST_TOUCH_COOKIE_NAME)

  if (cookie_content == undefined) {
    var values = calculate_first_touch()

    setCookie(FIRST_TOUCH_COOKIE_NAME, JSON.stringify(values))
  }
}

export function set_ad_click_ids() {
  const cookie_content = getCookie(AD_CLICK_IDS_COOKIE_NAME) || '{}'
  const existing_values = JSON.parse(cookie_content);
  const new_values = calculate_ad_click_ids();
  var values = {}

  Object.keys(AD_CLICK_IDS_KEYS).forEach(function (click_id_key) {
    values[click_id_key] = existing_values[click_id_key] || new_values[click_id_key];
  });

  setCookie(AD_CLICK_IDS_COOKIE_NAME, JSON.stringify(values))
}
